import { render, staticRenderFns } from "./packageType.vue?vue&type=template&id=773165a1&scoped=true"
import script from "./packageType.vue?vue&type=script&lang=js"
export * from "./packageType.vue?vue&type=script&lang=js"
import style0 from "./packageType.vue?vue&type=style&index=0&id=773165a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773165a1",
  null
  
)

export default component.exports